import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { SharedService } from '../services/shared.service';


@Injectable({
  providedIn: 'root'
})
export class ForgotPasswordService {

  constructor(private httpClient: HttpClient,private sharedService: SharedService) { }

  postDataFun(data){
    let url = this.sharedService.apiURL() + 'forgotpassword';
    const headers = new HttpHeaders({'Content-Type':'application/json; charset=utf-8'});
    return this.httpClient.post(url, JSON.stringify(data),{headers: headers});
  }
  
}
